import './program-history.scss';
//react
import { useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import format from 'date-fns/format';
import es from 'date-fns/locale/es';
//shared
import { PROGRAMS } from '../shared/graphql/programs';
import { SkeletonPrograms } from '../shared/components/skeleton-programs/skeleton-programs';
import Icon from '../shared/components/icon/icon';
import fitpalLogoApp from '../../assets/img/fitpalLogoApp.png'

import { DataNotFound } from '../shared/components/data-not-found/data-not-found';
import { DATA_NOT_FOUND } from '../programs/constants/DataNotFound';

//material
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { useEffect } from 'react';
import { sendPageView } from '../shared/services/analytics';
import { TITLE_PROGRAMS } from '../programs/constants/title';
import { Box } from '@mui/material';

const GetPrograms = () => {

    const location = useLocation();
    useEffect(() => {
        sendPageView(location.pathname + location.search, "Detalle de programa");
    }, [location]);

    let imageProgram: string = fitpalLogoApp;
    const { data, loading, error } = useQuery(PROGRAMS);

    if (loading) return <SkeletonPrograms></SkeletonPrograms>;
    if (error) console.log(`Submission error! ${error.message}`);

    let currentDate: any = new Date();
    currentDate = currentDate.toISOString().split('T')[0];

    let previousPrograms: any = [];

    if (data && data.teacherPrograms) {
        data.teacherPrograms.forEach((program: any) => {
            if (program.start_date.split(' ')[0] < currentDate) {
                previousPrograms.push({
                    id: program.program_id,
                    name: program.name,
                    description: program.description,
                    start: program.start_date,
                    end: program.end_date,
                    rate: program.rate,
                    total_booked: program.total_booked,
                    img: program.new_image ? program.new_image : imageProgram,
                });
            }
        })
    }

    return (
        <div className='container-program-detail-history'>
            {previousPrograms.length && (
                <>
                    <h2>Historial</h2>
                    <Grid container className='cards-class-program'>
                        {previousPrograms.map((program: any) => (
                            <Grid item xs={12} sm={12} md={12} my={12} key={program.id} className='card-class-program'>
                                <Grid container className='container-info-program'>
                                    <Grid item xs={7} className='info-program-section'>
                                        <Grid container>
                                            <Grid item>
                                                <img src={program.img} alt='fitpal' className='img-program' />
                                            </Grid>
                                            <Grid item justifyContent={'center'} alignContent={'center'} display={'grid'} className='ml-1'>
                                                <h4>{program?.name}</h4>
                                                <h5 className='date-program'>
                                                    {format(new Date(program.start), "dd MMM yyyy", { locale: es })}
                                                    &nbsp;-&nbsp;
                                                    {format(new Date(program.end), "dd MMM yyyy", { locale: es })}
                                                </h5>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={5} className='date-program info-program-icons'>
                                        <Box sx={{ display: 'inline-flex' }} className='box-detail'>
                                            <Icon name='user-check' width='25' height='25' color='#06BAA6' />
                                            <span>{program.total_booked ?? 0} usuarios</span>
                                        </Box>
                                        <Box sx={{ display: 'inline-flex' }} className='box-detail mr-0'>
                                            <Icon name='paid' width='25' height='25' color='#06BAA6' />
                                            <span>${program?.rate}</span>
                                        </Box>

                                    </Grid>
                                </Grid>
                                <div className='description-class-program'>
                                    <h4>Descripción</h4>
                                    <p>{program.description}</p>
                                </div>
                            </Grid>

                        ))}
                    </Grid>
                </>
            )}

            {!previousPrograms.length && (
                <DataNotFound data={DATA_NOT_FOUND} />
            )}
        </div>
    );
}

export default function ProgramHistory() {

    const navigate = useNavigate();

    const buttonClickProgramHistory = () => {
        navigate(`/programs`);
    }

    return (
        <div className='section-main-programs-history'>
            <Grid container justifyContent={'center'} className='main-programs-history'>
                <Grid item xs={5} className='title-programs'>
                    <Grid container justifyContent={'center'} alignItems={'center'} display={'flex'} direction={'column'} >
                        <h1>{TITLE_PROGRAMS.title}</h1>
                        <p className='mb-1'>{TITLE_PROGRAMS.description}</p>
                        <Button className='btn-fitpal-secondary btn-history' onClick={() => buttonClickProgramHistory()}>
                            Programas
                        </Button>
                    </Grid>
                </Grid>
                <Grid item xs={7} className='section-programs'>
                    <GetPrograms />
                </Grid>
            </Grid>
        </div>
    );
};